import { defineMessages } from 'react-intl';

export default defineMessages({
    businessIntroduction: {
        id: 'Introduce your business',
        defaultMessage: 'Introduce your business'
    },
    personalInformation: {
        id: 'Tell us about yourself',
        defaultMessage: 'Tell us about yourself'
    },
    businessProviders: {
        id: 'Which providers does your business use?',
        defaultMessage: 'Which providers does your business use?'
    },
    businessAccounts: {
        id: 'Verify your trading history',
        defaultMessage: 'Verify your trading history'
    },
    continueToStep: {
        id: 'Continue to step {key}',
        defaultMessage: `Continue to step {key}`
    },
    edit: {
        id: 'Edit',
        defaultMessage: 'edit'
    },
    optional: {
        id: 'Optional',
        defaultMessage: 'optional'
    },
    editOverlaySubmit: {
        id: 'Save and return to application',
        defaultMessage: 'Save and return to application'
    },
    editOverlayTitle: {
        id: 'Edit your previous answers',
        defaultMessage: 'Edit your previous answers'
    },
    completeApplication: {
        id: 'Complete application',
        defaultMessage: 'Complete application'
    },
    loading: {
        id: 'Loading',
        defaultMessage: 'Loading'
    },
    back: {
        id: 'Back',
        defaultMessage: 'Back'
    },
    finish: {
        id: 'Finish',
        defaultMessage: 'Finish'
    },
    minutes: {
        id: '_.panel_heading.minutes',
        defaultMessage: '{time, plural, one {1 min} other {{time} mins} }'
    },
    submit: {
        id: 'submit',
        defaultMessage: 'Submit'
    }
});
